// extracted by mini-css-extract-plugin
module.exports = {"skeletonForm":"classes_skeletonForm__2fT7m","skeletonCardsContainer":"classes_skeletonCardsContainer__13pOR"};